module.exports = __webpack_public_path__ + "/img/Son-Custom-Footprint-l0mKNa.svg";